import { ReactElement } from 'react';
import { HStack, Stack, Box, BoxProps } from '@chakra-ui/react';
import Image from 'next/image';

import CardRoot from 'components/atoms/card';
import CardTitle from 'components/atoms/card/title';
import CardSubTitle from 'components/atoms/card/subTitle';
import CardBody from 'components/atoms/card/body';
import { PropsWithChildren } from 'lib/@types';

export interface CardProps extends BoxProps {
  rightImageSrc?: string;
  rightImageAlt?: string;
  rightImageWidth?: number;
  rightImageHeight?: number;
  leftImageSrc: string;
  leftImageAlt: string;
  title: string;
  subtitle: string;
}

const Card = ({
  leftImageSrc,
  leftImageAlt,
  rightImageSrc,
  rightImageAlt,
  rightImageWidth,
  rightImageHeight,
  subtitle,
  children,
  title,
  ...props
}: PropsWithChildren<CardProps>): ReactElement => (
  <CardRoot bgColor='background.800' {...props}>
    <HStack spacing={[2, 4]} mb={8} justifyContent='space-between'>
      <HStack>
        <Box float='left' mr={[2, 4]}>
          <Image
            src={leftImageSrc}
            alt={leftImageAlt}
            width='50px'
            height='50px'
          />
        </Box>

        <Stack>
          <CardTitle>{title}</CardTitle>
          <CardSubTitle color='text.100'>{subtitle}</CardSubTitle>
        </Stack>
      </HStack>

      {rightImageSrc && (
        <Box w='35%' float='left' mr={4}>
          <Image
            src={rightImageSrc}
            width={rightImageWidth}
            height={rightImageHeight}
            alt={rightImageAlt}
            layout='intrinsic'
          />
        </Box>
      )}
    </HStack>

    <CardBody>{children}</CardBody>
  </CardRoot>
);

export default Card;
